import { render } from "./MiNTNewsDetail.vue?vue&type=template&id=747ef15d&scoped=true"
import script from "./MiNTNewsDetail.vue?vue&type=script&lang=js"
export * from "./MiNTNewsDetail.vue?vue&type=script&lang=js"

import "./MiNTNewsDetail.vue?vue&type=style&index=0&id=747ef15d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747ef15d"]])

export default __exports__